// Consent storage — single source of truth for cookie preferences.
// Per VDAI / EU 2024 guidance: opt-in only, no pre-checked optional categories,
// reject must be as accessible as accept, expire after 13 months.

export const CONSENT_STORAGE_KEY = "autobook-cookie-consent-v1";
export const CONSENT_EVENT = "autobook:consent-changed";
export const CONSENT_OPEN_EVENT = "autobook:consent-open";
export const CONSENT_TTL_MS = 13 * 30 * 24 * 60 * 60 * 1000; // ~13 months

export interface ConsentState {
  necessary: true;
  analytics: boolean;
  ts: string;
}

export function readConsent(): ConsentState | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as ConsentState;
    if (typeof parsed?.ts !== "string") return null;
    if (Date.now() - new Date(parsed.ts).getTime() > CONSENT_TTL_MS) return null;
    return { necessary: true, analytics: !!parsed.analytics, ts: parsed.ts };
  } catch {
    return null;
  }
}

export function writeConsent(next: { analytics: boolean }) {
  if (typeof window === "undefined") return;
  const value: ConsentState = {
    necessary: true,
    analytics: next.analytics,
    ts: new Date().toISOString(),
  };
  window.localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(value));
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: value }));
}

export function openConsentSettings() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(CONSENT_OPEN_EVENT));
}
